export const getPercentOf = ({ input, percent }) => (percent / 100) * input;
